import React, { useEffect } from "react";
import { useLocation } from "react-router";

interface Props {
  children?: Props;
}

const ScrollToTop: React.FC<Props> = ({ children }) => {
  // Only a change of path is a page change; a query-string update (e.g. the
  // language switch on /hiring) must not jump the viewport.
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <>{children}</>;
};

export default ScrollToTop;
